module.exports = "../study/imgs/maps/Nagano/GWQ8/Climate/TemperatureMin/Nagano_TemperatureMin_MRI_RCP85_End.png";